export const environment = {
  production: true,
  identityApiUrl: 'https://clinica-identity.l4zfiz.easypanel.host/api/v1/',
  apiUrl: 'https://clinica-api.l4zfiz.easypanel.host/api/v1/',
};

import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
